import React from 'react';

function Set({ type, set, updateSet }) {
    if (type === "weights") {
        return <WeightsSet set={set} updateSet={updateSet} />
    } else {
        return <CardioSet set={set} updateSet={updateSet} />
    }
}

function WeightsSet({ set, updateSet }) {
    const changeReps = event => updateSet("reps", event.target.value)
    const changeWeight = event => updateSet("weight", event.target.value)
    return (
        <div>
            <input className="w2" type="text" value={set.reps} onChange={changeReps} /> reps @ &nbsp;
            <input className="w3" type="text" value={set.weight} onChange={changeWeight}></input> kg
        </div>
    )
}

function CardioSet({ set, updateSet }) {
    const changeCals = event => updateSet("calories", event.target.value)
    const changeDur = event => updateSet("duration", event.target.value)
    return (
        <div>
            <input className="w2" type="text" value={set.calories} onChange={changeCals}></input> cal in &nbsp;
            <input className="w3" type="text" value={set.duration} onChange={changeDur}></input> mins
        </div>
    )
}

export default Set;